import type { Lang, SiteCopy } from '../i18n/types';
import { uniteGoPath } from './unite-go';
import { uniteBasePath } from './unite-base';

export function renderHomePage(siteCopy: SiteCopy, lang: Lang, esc: (s: string) => string): string {
  const h = siteCopy.hero;
  const p = siteCopy.products;
  const cta = siteCopy.homeCta;

  return `
    <section class="home-hero" id="top">
      <div class="home-hero__mesh" aria-hidden="true"></div>
      <div class="home-hero__inner home-hero__inner--solo">
        <div class="home-hero__copy reveal">
          <p class="home-hero__eyebrow">
            <span class="home-hero__eyebrow-dot" aria-hidden="true"></span>
            ${esc(h.eyebrow)}
          </p>
          <h1 class="home-hero__title">
            <span class="home-hero__title-line">${esc(h.title)}</span>
            <span class="home-hero__title-accent">${esc(h.titleAccent)}</span>
          </h1>
          <p class="home-hero__subtitle">${esc(h.subtitle)}</p>
          <div class="home-hero__actions">
            <a class="home-btn home-btn--primary" href="#contact">${esc(h.ctaPrimary)}</a>
            <a class="home-btn home-btn--outline" href="#products">${esc(h.ctaSecondary)}</a>
          </div>
        </div>
      </div>
    </section>

    <section class="section ub-hub" id="products">
      <div class="section__inner">
        <div class="ub-hub__grid">
          <a class="ub-hub__card reveal" href="${uniteBasePath(lang)}">
            <span class="ub-hub__badge">UniteBase</span>
            <h3>${esc(p.uniteBase.title)}</h3>
            <p>${esc(p.uniteBase.body)}</p>
            <span class="ub-hub__cta">${esc(p.uniteBase.cta)}</span>
          </a>
          <a class="ub-hub__card ub-hub__card--go reveal" href="${uniteGoPath(lang)}" style="transition-delay:80ms">
            <span class="ub-hub__badge">UniteGo</span>
            <h3>${esc(p.uniteGo.title)}</h3>
            <p>${esc(p.uniteGo.body)}</p>
            <span class="ub-hub__cta">${esc(p.uniteGo.cta)}</span>
          </a>
        </div>
      </div>
    </section>

    <section class="home-cta section">
      <div class="section__inner">
        <div class="home-cta__panel reveal">
          <h2 class="home-cta__title">${esc(cta.title)}</h2>
          <p class="home-cta__subtitle">${esc(cta.subtitle)}</p>
          <a class="home-btn home-btn--primary home-btn--lg" href="#contact">${esc(cta.button)}</a>
        </div>
      </div>
    </section>`;
}
